import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { trackGoogleAdsConversion, CONVERSION_LABELS } from '../utils/googleAdsTracking';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Track sign-up conversion when payment success page loads
    // This page only shows after successful payment, so it's a valid conversion
    if (CONVERSION_LABELS.SIGN_UP) {
      trackGoogleAdsConversion(CONVERSION_LABELS.SIGN_UP);
    }

    // Check auth state and force refresh token on mount
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // Force refresh token to get latest custom claims (webhook may have updated)
          await user.getIdToken(true);
          const tokenResult = await user.getIdTokenResult();
          const role = tokenResult.claims.role;
          
          // If user is active_user, redirect to MLS GPT with full app layout
          if (role === 'active_user') {
            console.log('User is active, redirecting to MLS GPT');
            navigate('/app/mls-gpt');
            return;
          }
        } catch (error) {
          console.error('Error checking role:', error);
        }
      }
      setChecking(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  if (checking) {
    return (
      <div className="payment-success-container" style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8fafc',
        padding: '2rem'
      }}>
        <div style={{ color: '#6b7280', fontSize: '1.2rem' }}>
          Verifying payment...
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-container" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8fafc',
      padding: '2rem'
    }}>
      <div className="success-card" style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '3rem',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{
          fontSize: '4rem',
          marginBottom: '1rem'
        }}>
          ✅
        </div>
        
        <h1 style={{
          color: '#059669',
          fontSize: '2rem',
          marginBottom: '1rem',
          fontWeight: 'bold'
        }}>
          Payment Successful!
        </h1>
        
        <p style={{
          color: '#6b7280',
          fontSize: '1.1rem',
          marginBottom: '2rem'
        }}>
          Thank you for subscribing to Vates Domus AI.
        </p>
        
        <div className="email-instructions" style={{
          backgroundColor: '#f0fdf4',
          border: '1px solid #059669',
          borderRadius: '8px',
          padding: '1.5rem',
          marginBottom: '2rem'
        }}>
          <h2 style={{
            color: '#065f46',
            fontSize: '1.25rem',
            marginBottom: '1rem',
            fontWeight: '600'
          }}>
            Your Account is Being Activated
          </h2>
          <p style={{
            color: '#065f46',
            marginBottom: '0.5rem'
          }}>
            We're processing your payment and activating your subscription.
          </p>
          <p style={{
            color: '#065f46',
            margin: 0
          }}>
            You'll receive a welcome email shortly with details about your account and subscription.
          </p>
        </div>
        
        <button 
          onClick={() => navigate('/signin')}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '0.75rem 2rem',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            marginBottom: '1rem',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
        >
          Go to Sign In
        </button>
        
        <p className="help-text" style={{
          color: '#6b7280',
          fontSize: '0.875rem',
          margin: 0
        }}>
          If you're not redirected automatically, please sign in to access your account.
        </p>
      </div>
    </div>
  );
}